import { ButtonUnstyled } from 'components/Button'
import Dropdown from 'components/Dropdown'
import { ReactComponent as Ellipsis } from 'icons/ellipsis-16.svg'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { MenuLink } from './MenuLink'
import { useMenuShareDrop, ShareDropPayload } from './useMenuShareDrop'

const ProjectOptionsButton = styled(ButtonUnstyled)`
  display: inline-flex;
  color: currentColor;

  justify-content: center;
  align-items: center;

  padding: 5px; /* stylelint-disable-line scales/space */

  &:focus {
    color: ${({ theme }) => theme.colors.gray};
  }
`

const StyledEllipsis = styled(Ellipsis)`
  width: 16px;
  height: 16px;
`

interface ActionableMenuLinkProps {
  icon: ({ isLinkActive }: { isLinkActive: boolean }) => React.ComponentType
  dropdownContent?: React.ReactNode
  onDropped?: (data: ShareDropPayload) => void
  to: string
  text: React.ReactNode
}

export const ActionableMenuLink = (props: ActionableMenuLinkProps) => {
  const { text, to, dropdownContent, icon, onDropped } = props
  const location = useLocation()

  const [isDropdownOpen, setDropdownOpen] = useState<boolean>(false)
  const { isDraggedOver, kind, ...dragEvents } = useMenuShareDrop({ onDropped })

  const isLinkActive = location.pathname === to

  const dropdown =
    dropdownContent && !isDraggedOver ? (
      <Dropdown
        toggle={
          <ProjectOptionsButton data-testid="project-options">
            <StyledEllipsis />
          </ProjectOptionsButton>
        }
        placement="bottom"
        onToggle={setDropdownOpen}
        hideOnClick={false}
        usePortal={true}>
        {dropdownContent}
      </Dropdown>
    ) : null

  return (
    <MenuLink
      icon={icon({ isLinkActive })}
      to={to}
      $forceHover={isDropdownOpen || isDraggedOver}
      text={text}
      action={dropdown}
      {...dragEvents}
    />
  )
}
